import r from"./_root.js";var o=r["__core-js_shared__"];export{o as default};
//# sourceMappingURL=_coreJsData.js.map
